import type { CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';
import { TEXT_DEFAULTS, type FontWeight } from './text-defaults';

export interface LegalesOpts {
  pieceId: string;
  text: string;
  fontSize?: number;
  fontWeight?: FontWeight;
  position: { left: number; top: number; width: number; height: number };
}

export function buildLegales(opts: LegalesOpts): CanvasJSONLikeObject {
  const { pieceId, text, position, fontWeight = 400 } = opts;
  const fontSize = opts.fontSize ?? 21;
  return {
    ...TEXT_DEFAULTS,
    type: 'Textbox',
    pieceId,
    text,
    fontSize,
    fontWeight,
    lineHeight: 1.16,
    textAlign: 'center',
    originY: 'top',
    left: position.left,
    top: position.top,
    width: position.width,
    height: position.height,
    fill: '#ffffff',
    objectCaching: false,
    lockScalingX: true,
    lockScalingY: true,
    lockRotation: true,
    autoFit: {
      minFontSize: fontSize,
      maxFontSize: fontSize,
      maxHeight: 331,
      snapTo: 2
    }
  };
}
